// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"Popover_popoverContent__Q_y9H","skeleton-loading":"Popover_skeleton-loading__i9nrw"};